import React, { useState, useRef, useEffect } from 'react';
export interface DurationInputProps {
  max: number;
  placeholder: string;
  inputStyles?: React.CSSProperties;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  name: string;
}
export const DurationInput: React.FC<DurationInputProps> = ({
  disabled,
  max,
  placeholder,
  inputStyles,
  value,
  onChange,
  ...props
}) => {
  const [internalValue, setInternalValue] = useState('');
  const [lastTypedCharacter, setLastTypedCharacter] = useState('');
  const [cursor, setCursor] = useState(0);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const maxLength = max.toString().length;

  useEffect(() => {
    setInternalValue(value.toString());
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue)) {
      //   const newCursor = inputRef.current?.selectionStart ?? 0;
      let val = inputValue;
      if (inputValue.length > maxLength && cursor < maxLength) {
        const arr = internalValue.split('');
        arr[cursor] = lastTypedCharacter;
        val = arr.join('');
      }
      if (parseInt(val, 10) <= max) {
        setInternalValue(val);
        onChange(parseInt(val, 10));
      }
      if (!inputValue?.length) {
        setInternalValue('');
        onChange(0);
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (inputRef.current) {
      setCursor(inputRef.current.selectionStart ?? 0);
      setLastTypedCharacter(e.key);
    }
  };
  const handleFocus = () => {
    inputRef?.current?.select();
  };
  const inputStyle: React.CSSProperties = {
    width: `${maxLength * 1.2}ch`,
    border: 'none',
    outline: 'none',
    textAlign: 'right',
    fontSize: '16px',
    backgroundColor: 'transparent',
    appearance: 'textfield',
    fontFamily: "'Inter', sans-serif",
    MozAppearance: 'textfield',
    padding: 0,
    paddingRight: '2px',
    boxSizing: 'content-box',
    color: disabled ? '#667085' : '#101828',
  };
  return (
    <input
      {...props}
      ref={inputRef}
      placeholder={placeholder}
      value={internalValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      style={{ ...inputStyle, ...inputStyles }}
      inputMode="numeric"
      onFocus={handleFocus}
      disabled={disabled}
    />
  );
};
